const modules = new Map([
  ['product-sku-component', () => import('@theme/product-sku')],
  ['product-inventory', () => import('@theme/product-inventory')],
  ['show-more-component', () => import('@theme/show-more')],
  ['volume-pricing', () => import('@theme/volume-pricing')],
  ['price-per-item', () => import('@theme/price-per-item')],
  ['volume-pricing-info', () => import('@theme/volume-pricing-info')],
  ['media-gallery', () => import('@theme/media-gallery')],
  ['deferred-media', () => import('@theme/media')],
  ['product-model', () => import('@theme/media')],
  ['rte-formatter', () => import('@theme/rte-formatter')],
  ['bmh-combo-physics', () => import('@theme/bmh-combo-physics')],
  ['bmh-home-community', () => import('@theme/bmh-home-community')],
  ['bmh-home-video', () => import('@theme/bmh-home-community')],
  ['bmh-home-catalog', () => import('@theme/bmh-home-community')],
]);
const selector = [...modules.keys()].join(',');
const deferred = new Set(['bmh-combo-physics', 'bmh-home-community', 'bmh-home-video', 'bmh-home-catalog']);
const pending = new Set();
let observer;
let nearObserver;
let nearElements = new WeakSet();

const load = (tag) => {
  if (!modules.has(tag) || pending.has(tag)) return;
  if (customElements.get(tag)) {
    modules.delete(tag);
    if (!modules.size) observer?.disconnect();
    return;
  }
  pending.add(tag);
  modules.get(tag)().then(() => {
    modules.delete(tag);
    if (!modules.size) observer?.disconnect();
  }).catch(error => {
    console.warn('[BeMyHome] Component could not be loaded:', tag, error);
  }).finally(() => pending.delete(tag));
};

const hydrate = (scope) => {
  if (!modules.size) return;
  const prepare = element => {
    if (!deferred.has(element.localName) || !('IntersectionObserver' in window) || customElements.get(element.localName)) {
      load(element.localName);
      return;
    }
    if (nearElements.has(element)) return;
    nearElements.add(element);
    nearObserver ??= new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        nearObserver.unobserve(entry.target);
        load(entry.target.localName);
      }
    }, { rootMargin: '600px 0px' });
    nearObserver.observe(element);
  };
  if (scope.nodeType === 1 && scope.matches(selector)) prepare(scope);
  scope.querySelectorAll(selector).forEach(prepare);
};

const resume = () => {
  hydrate(document);
  if (!modules.size || !document.body) return;
  observer ??= new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === 1) hydrate(node);
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
};

resume();
window.addEventListener('pagehide', () => { observer?.disconnect(); nearObserver?.disconnect(); nearElements = new WeakSet(); });
window.addEventListener('pageshow', resume);
